const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFilterConfig } from '@/Components/filterbar';
import { type Contact_Pagination_Fragment$data, type Contact_Pagination_Fragment$key, ContactsRootQuery, type Contacts_Root_Query } from '@/graphql/queries/Contact.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { loadQuery } from 'react-relay';
import type { DeepOmit, DeepWritable } from 'ts-essentials';
import { z } from 'zod';
const invalidateSchema = z.object({
  invalidate: z.boolean().optional()
});
const ContactFilterConfig = createFilterConfig({
  routeId: '/dash/crm/contacts/',
  options: {
    restoreOnMount: true
  }
}, {
  search: true
});
const schema = invalidateSchema.merge(ContactFilterConfig.schema);
type RelayData = ReturnType<typeof usePaginationFragment<Contacts_Root_Query, Contact_Pagination_Fragment$key>>;
type ContactsTableComponentProps = {
  fallback?: boolean;
} & Partial<RelayData>;
type ContactColumnNode = DeepOmit<DeepWritable<NonNullable<Contact_Pagination_Fragment$data['contacts']>['edges'][number]['node']>, {
  properties: never;
  formEntries: never;
  databaseId: never;
}>;
export const Route = createFileRoute('/dash/crm/contacts/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: zodValidator(schema),
  loader: match => {
    const shouldInvalidate = (match.location?.search as z.infer<typeof schema>)?.invalidate ?? false;
    return loadQuery<Contacts_Root_Query>(RelayEnvironment, ContactsRootQuery, {}, {
      fetchPolicy: shouldInvalidate ? 'store-and-network' : 'store-or-network'
    });
  }
});